import { useContext } from "react";
import dynamic from "next/dynamic";
import CenterWrapper from "../components/CenterWrapper";
import SideBar from "../SideBar";
import { BodyWrapper, BodyInnerWrapper } from "./ArticleBody.styled";
import LiveBlog from "../LiveBlog";
import ArticleFooter from "../components/ArticleFooter";
import Tags from "../Tags";
import Comments from "../Comments";
import Hero from "../Hero";
import { articleTypes } from "../Context/ArticleContext";
import { ArticleContext } from "../Context";
import Axiate from "../components/Custom/Axiate";
const Body = dynamic(() => import("./Body"));
const NewsLetterSignUp = dynamic(() => import("Components/NewsLetterSignUp"));

const ArticleBody = () => {
  const { refactoredArticle, memoizedArticleBody, isHeroOverride } =
    useContext<articleTypes>(ArticleContext);
  const {
    articleBody,
    isVideo,
    hero,
    sidebar,
    type,
    liveblog,
    isLiveBlog,
    id,
    hideNewsLetter,
    showComments,
    topics,
    dailyMotion
  } = refactoredArticle;

  return (
    <CenterWrapper>
      <BodyWrapper>
        <BodyInnerWrapper>
          {hero && (
            <Hero
              type={type}
              isVideo={isVideo}
              hero={hero}
              isHeroOverride={isHeroOverride}
              dailyMotion={dailyMotion}
            />
          )}
          <NewsLetterSignUp hideNewsLetter={hideNewsLetter} type={type} />
          <Body
            body={memoizedArticleBody}
            type={type}
            className="article-body"
          />
          <LiveBlog liveblog={liveblog} isLiveBlog={isLiveBlog} />

          {/*    <Axiate /> */}
          <Tags tags={topics} />
          {showComments && <Comments id={id} />}
          <ArticleFooter type={type} />
        </BodyInnerWrapper>
        <SideBar sidebarContent={sidebar && sidebar} type={type} />
      </BodyWrapper>
    </CenterWrapper>
  );
};

export default ArticleBody;
